<div class="container">
    <div class="mt-0 p-5 row bg-light border-top border-dark">
        <div class="col-12 col-md-6">
            <form [formGroup]="form" autocomplete="off">
                <div class="mb-1 row">
                    <div class="col-12 col-md-4">
                        <app-label controlName="currentPassword" class="col-form-label">{{ 'change_password.current_password' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8">
                        <div class="input-group">
                            <input [type]="fieldTextType[0] ? 'text' : 'password'" class="form-control" formControlName="currentPassword" />
                            <span class="input-group-text" (click)="toggleFieldTextType(0)">
                                <i
                                    class="bi bi-eye-slash"
                                    [ngClass]="{
                                        'bi bi-eye-slash': !fieldTextType[0],
                                        'bi bi-eye': fieldTextType[0]
                                    }"></i>
                            </span>
                        </div>
                        <app-field-error-message controlName="currentPassword"></app-field-error-message>
                    </div>
                </div>
                <div class="mb-1 row">
                    <div class="col-12 col-md-4">
                        <app-label controlName="newPassword" class="col-form-label">{{ 'change_password.new_password' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8">
                        <div class="input-group">
                            <input [type]="fieldTextType[1] ? 'text' : 'password'" class="form-control" formControlName="newPassword" />
                            <span class="input-group-text" (click)="toggleFieldTextType(1)">
                                <i
                                    class="bi bi-eye-slash"
                                    [ngClass]="{
                                        'bi bi-eye-slash': !fieldTextType[1],
                                        'bi bi-eye': fieldTextType[1]
                                    }"></i>
                            </span>
                        </div>
                        <app-field-error-message controlName="newPassword"></app-field-error-message>
                    </div>
                </div>
                <div class="mb-1 row">
                    <div class="col-12 col-md-4">
                        <app-label controlName="confirmPassword" class="col-form-label">{{ 'change_password.confirm_password' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8">
                        <div class="input-group">
                            <input [type]="fieldTextType[2] ? 'text' : 'password'" class="form-control" formControlName="confirmPassword" />
                            <span class="input-group-text" (click)="toggleFieldTextType(2)">
                                <i
                                    class="bi bi-eye-slash"
                                    [ngClass]="{
                                        'bi bi-eye-slash': !fieldTextType[2],
                                        'bi bi-eye': fieldTextType[2]
                                    }"></i>
                            </span>
                        </div>
                        <app-field-error-message controlName="confirmPassword"></app-field-error-message>
                        <app-form-group-error-message errorMessage="password_does_not_match"></app-form-group-error-message>
                    </div>
                </div>
                <br />
                <div class="my-1">
                    <button type="submit" [appClickWait]="send" class="btn btn-primary float-end">
                        {{ 'common.save' | translate }}
                    </button>
                </div>
            </form>
        </div>
        <div class="ms-4 p-2">
            <app-html-viewer [type]="type"></app-html-viewer>
        </div>
    </div>
</div>
